module.exports = __webpack_public_path__ + "static/media/4.b2ea08e0.png";